import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LearnizState, SafeHtmlPipe, WordingPipe } from '@jump-tools-front/shared';
import { Store } from '@ngxs/store';

@Component({
  selector: 'learniz-landing-content',
  templateUrl: './landing-content.component.html',
  styleUrls: ['../landing-section.scss', './landing-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SafeHtmlPipe, WordingPipe],
})
export class LandingContentComponent {
  private _store = inject(Store);
  readonly model$ = this._store.select(LearnizState.getLearniz);
}
